import { Pipe, PipeTransform } from '@angular/core';
import { JOB_POSITION } from '@app/config/job-position.enum';

@Pipe({
  name: 'positionCurrentPipe'
})
export class PositionCurrentPipePipe implements PipeTransform {

  transform(value: any): string {


    if (!value)
      return '';

    const arrInstitution: Array<any> = (function (raw) {
      try { return JSON.parse(raw); }
      catch (err) { return []; }
    })(value);

    if (arrInstitution.length === 0)
      return '';

    return arrInstitution.map(x => {

      if (Array.isArray(x?.workPosition)) {

        return Array.from(x?.workPosition)
          .map(p => {

            return JOB_POSITION.find(e => +e.id === +p)?.text;

          }).join(", ")
          .concat(" en ", x?.workInstitution)

      }

      return x?.workInstitution

    }).join(" & ");

  }
}
